<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('edit_groups_by_date') }} <button-open-help-modal :color="'dark'" :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-010' : 'ASB-010'"/></h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div>
                <label>
                    <input type="radio" :value="'month'" v-model="analyzeLevel.date_segregation"/>
                    {{ __('division_into_month') }}
                </label>
            </div>
            <div>
                <label>
                    <input type="radio" :value="'year'" v-model="analyzeLevel.date_segregation"/>
                    {{ __('division_into_year') }}
                </label>
            </div>
        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                </div>
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-primary" @click="saveDateGroup()">{{__('save')}}</button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalEditDateGroup",
    data: function () {
        return {
            visible: false,
        }
    },
    props: {
        analyzeLevel: {
            type: Object
        },
        analyzeType: {
            type: String
        },
    },
    methods:{
        saveDateGroup: function (){
            this.$emit('saveDateGroup')
        }
    }
}
</script>

<style scoped>

</style>
